var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-header"},[_c('b-skeleton',{attrs:{"circle":"","width":"40px","height":"40px","animated":true}}),_vm._v(" "),_c('b-skeleton',{attrs:{"width":"400px","height":"40px","animated":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }